import { render, staticRenderFns } from "./PlantillasMantenimiento.vue?vue&type=template&id=745ea5c6&scoped=true"
import script from "./PlantillasMantenimiento.vue?vue&type=script&lang=js"
export * from "./PlantillasMantenimiento.vue?vue&type=script&lang=js"
import style0 from "./PlantillasMantenimiento.vue?vue&type=style&index=0&id=745ea5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ea5c6",
  null
  
)

export default component.exports